import * as React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { usePayPalScriptReducer, PayPalButtons } from '@paypal/react-paypal-js';

import './index.scss';

const Donation = () => {
  const [{ isPending }] = usePayPalScriptReducer();
  const [amount, setAmount] = React.useState('10.00');
  const amountRef = React.useRef('10.00');
  const [validated, setValidated] = React.useState(false);
  const [approved, setApproved] = React.useState(false);
  const [recordId, setRecordId] = React.useState('');

  const createOrder = (data, actions) => {
    console.log(actions);
    const order = {
      purchase_units: [
        {
          amount: {
            value: amountRef.current,
            currency_code: "USD",
            breakdown: {
              item_total: {
                currency_code: "USD",
                value: amountRef.current,
              }
            }
          },
          items: [
            {
              name: "AAD Booster Club Donation",
              description:
                "All proceeds directly support the AAD Booster Club mission.",
              quantity: "1",
              unit_amount: {
                currency_code: "USD",
                value: amountRef.current,
              },
              category: "DONATION"
            }
          ],
          description: `$${amountRef.current} donation to the AAD Booster Club`
        },
      ],
    };
    // This function is called when the user clicks the PayPal button.
    // You can customize the donation amount here.
    console.log(order);
    return actions.order.create(order);
  };

  const onApprove = (data, actions) => {
    // This function is called when the donation is approved by PayPal.
    return actions.order.capture().then((details) => {
      alert(`Donation of ${details.purchase_units[0].amount.value} ${details.purchase_units[0].amount.currency_code} successful!`);
      // You can perform further actions here, e.g., update your database.
    });
  };

  const onError = (err) => {
    console.error("PayPal error:", err);
    alert("An error occurred during the PayPal transaction.");
  };

  const onCancel = (data) => {
    console.log("PayPal transaction cancelled:", data);
    alert("PayPal transaction cancelled.");
  };

  return (
    <Container>
      <Row>
        <Col />
        <Col sm="6" className="text-center mt-4">
          {isPending ? <Spinner className="m-auto" animation="border" variant="secondary" /> : (
            <>
              <p>Use the below form to donate a preset amount to the AAD Booster Club. For donations over $500.00, please contact us directly.<br /><br /><strong>Thank you for your contribution!</strong></p>
              <Form.Select name="donation-amount" className="my-3 p-1 fs-4" onChange={(e) => amountRef.current = e.target.value}>
                <option value="10.00">$ 10.00</option>
                <option value="25.00">$ 25.00</option>
                <option value="50.00">$ 50.00</option>
                <option value="100.00">$ 100.00</option>
                <option value="500.00">$ 500.00</option>
              </Form.Select>
              <PayPalButtons
                style={{ color: "black", label: "donate" }}
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
                onCancel={onCancel}
              />
            </>
          )}
        </Col>
        <Col />
      </Row>
    </Container>
  );
}

export default Donation;
